var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{staticClass:"text-center",attrs:{"value":!!_vm.alert,"dismissible":"","border":"left","type":"error"},on:{"input":_vm.closeAlert}},[_vm._v(" "+_vm._s(_vm.alert)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }